<template>
  <div class="page-container has-action">
    <van-nav-bar fixed title="充值" left-arrow @click-left="goableBack()" />
    <div class="recharge recharge_3">
      <div class="block">
        <div class="fs-18">充值金额</div>
        <van-field
          class="tian-amount mt-10"
          type="number"
          v-model="payForm.tradeAmount"
          @blur="setAmountInMin"
          :placeholder="rechargeTxt"
        >
          <div slot="left-icon">￥</div>
        </van-field>
      </div>

      <div class="block">
        <van-field
          v-model="payForm.name"
          label="真实姓名"
          input-align="right"
          clearable
          placeholder="请输入真实姓名"
        />
        <van-field
          v-model="payForm.idNumber"
          label="身份证号"
          input-align="right"
          clearable
          placeholder="请输入身份证号"
        />
        <div class="color-red mt-10">*请填写本人真实信息，核实后不可修改</div>
      </div>

      <div class="block mt-5">
        <van-field
          type="number"
          v-model="payForm.cardNo"
          label="银行卡"
          input-align="right"
          clearable
          placeholder="请输入银行卡号"
        />
        <van-field
          v-model="bankName"
          readonly
          clearable
          input-align="right"
          label="开户行"
          placeholder="请选择开户行"
          @click="bankPicker.show = true"
        />
        <van-field
          v-model="payForm.mobile"
          label="手机号"
          input-align="right"
          clearable
          placeholder="请输入银行预留手机号"
        />
      </div>

      <div class="page-action">
        <van-button
          class="payment-next-step"
          @click="onGetpayurl"
          type="danger"
          size="large"
          >确定</van-button
        >
      </div>
    </div>
    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker
        show-toolbar
        value-key="bankName"
        :columns="bankPicker.columns"
        :loading="bankPicker.loading"
        @cancel="bankPicker.show = false"
        @confirm="confirmBankPicker"
      />
    </van-popup>
    <BlEft
      v-model="eftShow"
      :payType="payType"
      title="金额超出上限 请使用线下转账"
    ></BlEft>
  </div>
</template>

<script>
import storage from "@/utils/storage";
import * as BankcardApi from "@/api/bankcard";
import * as PayApi from "@/api/pay";
import BlEft from "@/components/bl-eft";
import { banklist } from "@/api/pay";
import "./idx.less";

import {
  Tag,
  Col,
  NavBar,
  Button,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Toast,
  Dialog,
  Field,
  Checkbox,
  Popup,
  Picker,
} from "vant";

export default {
  components: {
    BlEft,
    [Tag.name]: Tag,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },

  data() {
    return {
      bankName: "",
      rechargeTxt: "充值金额 1 元起",
      bankPicker: {
        show: false,
        loading: false,
        columns: [],
      },
      payForm: {
        tradeAmount: "", //  金额
        terminal: "H5", // 终端
        name: "", // 真实姓名
        idNumber: "", // 身份证
        cardNo: "", //  银行卡号
        bankId: "", //   开户行
        mobile: "", //  银行预留手机号
      },
      payType: {},
      eftShow: false,
    };
  },

  beforeMount() {
    this.getBankList();
    PayApi.paytype()
      .then((data) => {
        this.payType = data;
      })
      .catch((e) => {
        Toast(e.msg || e.message);
      });
  },

  methods: {
    // 失去焦点，如果金额小于最小起购金额。自动填充最小起购金额
    setAmountInMin() {
      let amount = Number(this.payForm.tradeAmount);
      if (amount < 1) {
        Toast(this.rechargeTxt);
        this.payForm.tradeAmount = 1;
        return;
      }
    },

    //   确认银行卡的开户行
    confirmBankPicker(value) {
      this.bankName = value.bankName;
      this.payForm.bankId = value.id;
      this.bankPicker.show = false;
    },

    getBankList() {
      this.bankPicker.loading = true;
      banklist()
        .then((data) => {
          this.bankPicker.columns = data;
          this.bankPicker.loading = false;
        })
        .catch((e) => {
          Toast(e.msg || e.message);
        });
    },

    // 表单验证
    getFormVerify() {
      let { name, idNumber, cardNo, mobile } = this.payForm;
      if (!name) return "请输入真实姓名！";
      if (!idNumber) return "请输入身份证号！";
      if (!cardNo) return "请输入银行卡号！";
      if (!mobile) return "请输入银行预留手机号！";
    },

    // 前往支付
    onGetpayurl() {
      if (this.getFormVerify()) {
        Toast(this.getFormVerify());
        return;
      }
      this._showLoading();
      PayApi.recharge(this.payForm)
        .then((data) => {
          this._dismissLoading();
          if (!data) {
            Toast("服务器繁忙, 请稍后再试");
            return;
          }

          location.href = data;
        })
        .catch((e) => {
          this._dismissLoading();
          if (e.code == 2006) {
              //如果在线支付功能没有开启，就跳转到离线充值页面
            this.$toast({
              message: "本次充值超过银行限额，请使用线下转账充值",
              onClose: () => {
                this.$router.push({
                  name: "recharge_offline",
                  query: { redirect: this.$route.fullPath },
                });
              },
            });
            return;
          } else {
            Toast(e.msg || e.message);
          }
        });
    },

    onShowQuota() {
      Toast("查看限额");
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .tian-amount {
  .van-field__left-icon {
    font-weight: 600;
  }
  .van-field__left-icon,
  .van-field__control {
    font-size: 32px;
    line-height: 36px;
  }
}
</style>
